import { render, staticRenderFns } from "./TableTextDecoration.vue?vue&type=template&id=846a3cd2&scoped=true&"
import script from "./TableTextDecoration.vue?vue&type=script&lang=ts&"
export * from "./TableTextDecoration.vue?vue&type=script&lang=ts&"
import style0 from "./TableTextDecoration.vue?vue&type=style&index=0&id=846a3cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846a3cd2",
  null
  
)

export default component.exports